import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemsService {

  private readonly url = 'mag-base/geos';

  constructor(private http: HttpClient) {
  }

  getList(geoId: string, toGeoTypeEnumId: string): Observable<any> {
    return this.http.get(`${this.url}/${geoId}/assocs?toGeoTypeEnumId=${toGeoTypeEnumId}`);
  }
}
